import { render, staticRenderFns } from "./live-broadcast-pop.vue?vue&type=template&id=16da8ed9&scoped=true&"
import script from "./live-broadcast-pop.vue?vue&type=script&lang=js&"
export * from "./live-broadcast-pop.vue?vue&type=script&lang=js&"
import style0 from "./live-broadcast-pop.vue?vue&type=style&index=0&id=16da8ed9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16da8ed9",
  null
  
)

export default component.exports